import { Injectable } from '@angular/core';

@Injectable({
    providedIn: 'root',
})
export class UserAgentService {
    userAgent = window.navigator.userAgent;


    public isBeaconFound(): boolean {
        return /Beacon/i.test(this.userAgent);
    }
}
